/***
 * 公用常量配置
 */
export default {
  install(Vue) {
    //会员等级
    Vue.prototype.memberUser_all = [
      {
        value: "0",
        label: '店铺会员'
      },
      {
        value: "1",
        label: '普通会员'
      },
      {
        value: "2",
        label: '高级会员'
      },
      {
        value: "3",
        label: 'VIP会员'
      },
      {
        value: "4",
        label: '至尊VIP会员'
      }
    ];
    //性别
    Vue.prototype.sex_all = [
      {
        value: '0',
        label: '未知'
      },
      {
        value: '1',
        label: '男'
      },
      {
        value: '2',
        label: '女'
      },
    ];
    //全局引用，并且或者
    Vue.prototype.sureOr_all = [
      {
          id: 0,
          label: '并且'
      },
      {
          id: 1,
          label: '或者'
       }
     ];
    //职业
    Vue.prototype.worker_all = [
      {
        value: '1',
        label: '学生'
      },
      {
        value: '2',
        label: '白领'
      },
      {
        value: '3',
        label: '公务员'
      }
      ,
      {
        value: '4',
        label: 'IT'
      }
      ,
      {
        value: '5',
        label: '金融族'
      },
      {
        value: '6',
        label: '居家族'
      },
      {
        value: '7',
        label: '医护人员'
      },
      {
        value: '8',
        label: '其他'
      }
    ];

    // type: 1表示允许小数点 0表示整数, min表示 低于min过滤掉
    Vue.prototype.getNumberData = function(e, type, min = 1, max = 99999999) {
      const str = String(e)
      let num = type ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1').replace(/[^\d.]/g, "") : str.replace(/[^\d]/g, '')
      if (num < min && min) {
        num = "";
      }
      if(num > max) {
        num = max
      }
      return num
    }

    
    // type: 1：传值 0：传input实例
    // e: 值或者input实例
    // decimal: 1表示允许小数点 0表示整数, 
    // min：允许传入最小值，小于这个值时返回""
    Vue.prototype.getNumberData2 = function(type, e, decimal = 0, min = 1, max = -1) {
      let str = ""
      if(type) {
        str = String(e)
      } else {
        str = String(e.target.value)
      }
      
      let num = decimal ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') : str.replace(/[^\d]/g, '')
      if (num < min) {
        num = "";
      }
      if (max != -1 && max < num) {
        num = max;
      }
      return num
    }
  }
}